import { Injectable } from '@angular/core';
import { AssetJsonModel } from '../assets.json.model';
import { AppCollection } from '../../app.config';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';

@Injectable({
  providedIn: 'root'
})
export class AssetService extends BaseCollectionService<AssetJsonModel, AppCollection> {
  protected ctor = AssetJsonModel;
}
